import { combineEpics } from 'redux-observable'
import * as starter from './starter'

export const rootEpic = combineEpics(
  starter.loadingEpic
)
